module.exports = __webpack_public_path__ + "static/img/desicionB.0a724234.png";